import CreditCardIcon from "images/credit_card.svg?react";
import ApplePayIcon from "images/apple-pay.svg?react";
import GooglePayIcon from "images/google-pay.png";
import { PaymentMethod } from "services/paymentMethods";
import classNames from "classnames";
import styles from "./style.module.scss";

interface Props {
  paymentMethod: PaymentMethod;
  className?: string;
}

export default function PaymentMethodIcons({ paymentMethod, className }: Props) {
  switch (paymentMethod.wallet?.type) {
    case "apple_pay":
      return <ApplePayIcon className={classNames(styles.defaultIcon, className)} />;
    case "google_pay":
      return (
        <img
          src={GooglePayIcon}
          alt="Google pay logo"
          className={classNames(styles.defaultIcon, className)}
        />
      );
    default:
      return <CreditCardIcon className={classNames(styles.defaultIcon, className)} />;
  }
}
